// Shared centered column for the chat transcript and composer. Prose keeps
// a comfortable reading width in the docked sidebar; on wide surfaces
// (fullscreen/floating expanded chat) the column widens so dynamic widgets
// get the available space instead of leaving half the pane empty. The
// container is the chat pane (`@container/chat-pane` in chat_view).
export const CHAT_COLUMN_CLASS =
    'mx-auto w-full max-w-3xl @[68rem]/chat-pane:max-w-5xl';
